import { Injectable } from '@angular/core';

import {LOCALSTORAGE_KEY_PITCH} from '../../defines/client.const';
import {interp} from '../../defines/common.func';


const MAX_COUNT = 10;

/**
 * 사용자의 Pitch 개인화 정보를 계산하고, LOAD/SAVE 한다.
 * 중간값을 계산하는데, 최대 10개의 데이터를 사용한다.
 */
@Injectable({
  providedIn: 'root'
})
export class PitchService {

  public midPitch: number | null = null;       // pitch 그래프에서 중간값 (중간 점선이 표시되는 위치)
  private countPitch: number = 0;    // 몇개의 데이터를 수집했는지 수치

  constructor() {
    this.load();

    console.warn('PitchService::constructor()', this.midPitch, this.countPitch);
  }


  // 중간 값 (중간 점선이 표시되는 위치)를 업데이트 한다.
  public setMid(mid: number): number {
    ++this.countPitch;

    if (this.countPitch > MAX_COUNT) {
      if (this.midPitch === null) {
        throw new Error('PitchService::setMid() midPitch is null');
      }
      const midPitch = interp(this.midPitch, mid, 1 / MAX_COUNT);
      console.warn('PitchService::setMid() midPitch = ', midPitch, this.midPitch, mid);
      if (!isNaN(midPitch)) {
        this.midPitch = midPitch;
      }
      this.countPitch = MAX_COUNT;
    }
    else if (this.countPitch > 1) {
      if (this.midPitch === null) {
        // throw new Error('PitchService::setMid() midPitch is null');
        console.error('PitchService::setMid() midPitch is null');
        this.midPitch = mid;
      }
      const midPitch = interp(this.midPitch, mid, 1 / this.countPitch);
      if (!isNaN(midPitch)) {
        this.midPitch = midPitch;
      }
    }
    else {
      this.midPitch = mid;
    }
    this.save();

    return this.midPitch;
  }

  public reset(): void {
    this.countPitch = 0;
    this.midPitch = null;

    this.save();
  }

  toJSON(): any {
    return {
      mid:            this.midPitch,
      count:          this.countPitch,
    };
  }

  public load(): void {
    const txtPitches = localStorage.getItem(LOCALSTORAGE_KEY_PITCH);
    const pitches = txtPitches ? JSON.parse(txtPitches) : null;

    this.midPitch       = pitches?.mid   ?? null;
    this.countPitch     = pitches?.count ?? 0;

    console.log('PitchService::load()', this);
  }

  public save(): void {
    localStorage.setItem(LOCALSTORAGE_KEY_PITCH, JSON.stringify(this));
  }
}
